export default "__VITE_ASSET__BfELOHzB__";